import { render, staticRenderFns } from "./confirm-order.vue?vue&type=template&id=776fb6cb&"
import script from "./confirm-order.vue?vue&type=script&lang=js&"
export * from "./confirm-order.vue?vue&type=script&lang=js&"
import style0 from "./confirm-order.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports